import classNames from 'classnames/bind';

import styles from './Products.module.scss';
import { PRODUCTS } from '../constants';

const cx = classNames.bind(styles);

const Products = () => {
  return (
    <>
      <p className={cx('title')}>LEVRAI MULTI BALM</p>
      <ul className={cx('container')}>
        {PRODUCTS.map((product, index) => (
          <li key={index}>
            <div className={cx('image')}>
              <img src={product.closeImage} alt={product.title} />
            </div>
            <div className={cx('info')}>
              <p className={cx(['name', product.title])}>
                {product.name} <span className={cx('title')}>{product.title}</span>
              </p>
              <p className={cx('desc1')}>{product.desc1}</p>
              <p className={cx('desc2')}>{product.desc2}</p>
              <p className={cx('tags')}>
                {product.tags.map((tag, index) => (
                  <span key={index}>#{tag}</span>
                ))}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Products;
